import { Tooltip } from "antd"
import { useMemo } from "react"
import styled from "styled-components"

import { useFirebaseContext } from "#contexts/FirebaseContextProvider"
import { camelToWords } from "#utils/textFormatters"

const SEmoji = styled.span`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const TagWithTooltip = ({ tagName }: { tagName: string }) => {
  const { tagsByValue, allergiesByValue } = useFirebaseContext()

  const { icon, tooltip } = useMemo(() => {
    const match = tagsByValue[tagName] ?? allergiesByValue[tagName]

    return {
      icon: match?.icon || "",
      tooltip: match?.label || camelToWords(tagName),
    }
  }, [tagsByValue, allergiesByValue, tagName])

  return (
    <Tooltip title={tooltip}>
      <SEmoji style={{ backgroundColor: "transparent", userSelect: "none" }}>
        {icon || tagName.charAt(0).toUpperCase()}
      </SEmoji>
    </Tooltip>
  )
}

export default TagWithTooltip
